(() => {
  'use strict';

  const loader = document.currentScript || document.querySelector('script[data-drevos-binotel-loader]');
  if (!loader || window.__drevosBinotelLoader) return;
  window.__drevosBinotelLoader = true;

  const calltrackingSrc = loader.dataset.calltrackingSrc;
  const getcallSrc = loader.dataset.getcallSrc;
  // GetCall ma prawo ładować się tylko na urządzeniu desktopowym z precyzyjnym
  // wskaźnikiem. Telefony i tablety z coarse pointer nie pobierają widżetu wcale.
  const desktop = window.matchMedia('(min-width: 960px) and (hover: hover) and (pointer: fine)');
  const externalLoads = window.__drevosExternalLoads = window.__drevosExternalLoads || {};
  const interactionEvents = ['pointerdown', 'touchstart', 'keydown'];

  const markPhase = (name, lifetime) => {
    externalLoads[name] = Date.now() + lifetime;
  };

  const clearPhaseLater = (name, delay) => {
    window.setTimeout(() => {
      if (externalLoads[name] && externalLoads[name] <= Date.now()) delete externalLoads[name];
    }, delay + 50);
  };

  const loadScript = (src, name) => {
    if (!src || document.querySelector(`script[data-drevos-external="${name}"]`)) return;

    markPhase(name, 15000);
    const script = document.createElement('script');
    script.src = src;
    script.async = true;
    script.fetchPriority = 'low';
    script.dataset.drevosExternal = name;
    script.addEventListener('load', () => {
      markPhase(name, 5000);
      clearPhaseLater(name, 5000);
      document.dispatchEvent(new CustomEvent('drevos:external-script-loaded', { detail: { name } }));
    }, { once: true });
    script.addEventListener('error', () => {
      markPhase(name, 2000);
      clearPhaseLater(name, 2000);
    }, { once: true });
    document.head.appendChild(script);
  };

  // Call tracking remains available on every viewport and starts as soon as parsing is complete.
  loadScript(calltrackingSrc, 'binotel_calltracking');

  let getcallRequested = false;
  const removeInteractionListeners = () => {
    interactionEvents.forEach((eventName) => document.removeEventListener(eventName, requestGetCall));
  };

  const loadGetCall = () => {
    if (getcallRequested || !desktop.matches) return;
    getcallRequested = true;
    removeInteractionListeners();
    loadScript(getcallSrc, 'binotel_getcall');
  };

  const requestGetCall = () => {
    if (getcallRequested || !desktop.matches) return;
    removeInteractionListeners();
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(loadGetCall, { timeout: 1500 });
    } else {
      window.setTimeout(loadGetCall, 600);
    }
  };

  const scheduleGetCallAfterLoad = () => {
    if (!desktop.matches || getcallRequested) return;
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(loadGetCall, { timeout: 6000 });
    } else {
      window.setTimeout(loadGetCall, 6000);
    }
  };

  const installDesktopSchedule = () => {
    if (!desktop.matches || getcallRequested) return;
    interactionEvents.forEach((eventName) => {
      document.addEventListener(eventName, requestGetCall, { passive: true, once: true });
    });
    if (document.readyState === 'complete') scheduleGetCallAfterLoad();
    else window.addEventListener('load', scheduleGetCallAfterLoad, { once: true });
  };

  installDesktopSchedule();
  if (typeof desktop.addEventListener === 'function') desktop.addEventListener('change', installDesktopSchedule);
  else if (typeof desktop.addListener === 'function') desktop.addListener(installDesktopSchedule);
})();
